import { toProjectBankInput } from './projectBankInput';

/**
 * `Project.bank` field saved by the block project-bank-rental-income. Must match
 * `ProjectBankRentalIncomeInput` in the API schema.
 */
export const PROJECT_BANK_RENTAL_INCOME_INPUT_FIELDS = ['hasRentalIncome'];

/** `ProjectBankRentalIncomeInput` from the block object. */
export const toProjectBankRentalIncomeInput = (project) =>
  toProjectBankInput(project, PROJECT_BANK_RENTAL_INCOME_INPUT_FIELDS);
